import { openDB } from 'idb';

const DB_NAME = 'vuexDB';
const STORE = 'state';

export const dbPromise = openDB(DB_NAME, 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(STORE)) {
      db.createObjectStore(STORE);
    }
  },
});

export async function saveState(key, state) {
  const db = await dbPromise;
  return db.put(STORE, state, key);
}

export async function loadState(key) {
  const db = await dbPromise;
  return db.get(STORE, key);
}